module.exports = __webpack_public_path__ + "img/flag-europe-europian-cash-otl.8ef5c020.svg";